import styled from 'styled-components';

interface NavLinkProps {
  href: string;
  label: string;
  onClick?: () => void;
}

const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`;

const NavLink = ({ href, label, onClick }: NavLinkProps) => {
  return (
    <li>
      <StyledLink href={href} onClick={onClick}>
        {label}
      </StyledLink>
    </li>
  );
};

export default NavLink;
